module.exports = __webpack_public_path__ + "img/a18.f6596fbf.jpg";